import React, { useEffect } from "react";
import styled, { withTheme } from "styled-components";
import { NavLink } from "react-router-dom";

import Helmet from "react-helmet";

//import "../../vendor/roundedBarCharts";

import { makeStyles, useTheme } from "@mui/styles";
import { withStyles } from "@mui/styles";
import { spacing } from "@mui/system";
import { getChipVariant } from '../../../utils/chipStyles';

import {
  Paper,
  Avatar as MuiAvatar,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card,
  CardContent,
  Chip,
  Divider as MuiDivider,
  Grid,
  LinearProgress as MuiLinearProgress,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Switch,
} from "@mui/material";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import TableContainer from "@mui/material/TableContainer";

// Redux Components
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  // Generic Types status changing types
  APL_GET_GEN_TYPES_REQUEST,
  APL_GET_GEN_TYPES_RESPONSE,
  APL_GET_GEN_TYPES_FAILURE,
  getAllGenericDBStatusOrTypeData,
} from "../api/actions";

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  percentDif: {
    textAlign: "right",
    color: theme.palette.success.main,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.common.white,
  },
  loadingIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  billingWizardContent: {
    maxHeight: "60%",
  },
  paper: {
    padding: "1%",
  },
}));

const MissingTypeIDValue = "Unknown";

// Generic Tag Item
// NOTE:  Expects (In props){type (the name in the store as a string), isLoading, typeId, customStyles(optional), condensed(optional, uses small styling), showTitle(optional, toggles title)}
const StatusTag = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  
  // Default Values for status settings
  var isLoading = false;
  var showTitle = true;
  var condensed = false;
  if (typeof props.isLoading === "boolean") {
    isLoading = props.isLoading;
  }
  if (typeof props.showTitle === "boolean") {
    showTitle = props.showTitle;
  }
  if (typeof props.condensed === "boolean") {
    condensed = props.condensed;
  }

  const chipOptions = { filled: props.filled === true };

  // Modern pre-defined tags using theme-based styling
  // Color prop can override the default variant (e.g., color="error" for red)
  const filledSx = chipOptions.filled ? { color: '#ffffff !important', '& .MuiChip-label': { color: '#ffffff !important' } } : undefined;

  if (props.type == "Alert" && props.label) {
    const variantType = props.color || 'alert';
    const chipProps = getChipVariant(variantType, theme, chipOptions);
    return (
      <Chip
        label={props.label}
        {...chipProps}
        sx={filledSx ? { ...chipProps.sx, ...filledSx } : chipProps.sx}
        size={condensed ? "small" : "medium"}
      />)
  }
  else if (props.type == "Warning" && props.label) {
    const variantType = props.color || 'warning';
    const chipProps = getChipVariant(variantType, theme, chipOptions);
    return (
      <Chip
        label={props.label}
        {...chipProps}
        sx={filledSx ? { ...chipProps.sx, ...filledSx } : chipProps.sx}
        size={condensed ? "small" : "medium"}
      />)
  }
  else if (props.type == "Success" && props.label) {
    const variantType = props.color || 'success';
    const chipProps = getChipVariant(variantType, theme, chipOptions);
    return (
      <Chip
        label={props.label}
        {...chipProps}
        sx={filledSx ? { ...chipProps.sx, ...filledSx } : chipProps.sx}
        size={condensed ? "small" : "medium"}
      />)
  }
  else if (props.type == "Default" && props.label) {
    const variantType = props.color || 'default';
    const chipProps = getChipVariant(variantType, theme, chipOptions);
    return (
      <Chip
        label={props.label}
        {...chipProps}
        sx={filledSx ? { ...chipProps.sx, ...filledSx } : chipProps.sx}
        size={condensed ? "small" : "medium"}
      />)
  }

  // If the requested code doesnt Exist, return an error tag to alert the dev they screwed up (remove on production, here to help troubleshoot)
  if (!props.apl.genericTypes[props.type]) {
    // Checks type
    const chipProps = getChipVariant('error', theme);
    return (
      <Chip
        label={"ERROR! Type Not Found: " + props.type}
        {...chipProps}
        size={condensed ? "small" : "medium"}
      />
    );
  }



  // Checks if either module is still loading a piece before continuing
  const typeData = props.apl.genericTypes[props.type];
  const dataArray = typeData?.data;
  const hasNoData = !dataArray || (Array.isArray(dataArray) && dataArray.length === 0);
  if (
    typeData?.isLoading ||
    isLoading ||
    typeData?.status == null ||
    hasNoData
  ) {
    return <></>; // Returns nothing until data is loaded (avoids flash of "Unknown")
  }
  if (!props.typeId) {
    // Checks typeId
    const chipProps = getChipVariant('error', theme);
    return (
      <Chip
        label={"ERROR! No typeId passed"}
        {...chipProps}
        size={condensed ? "small" : "medium"}
      />
    );
  }

  var chipStyles = { fontSize: "100%", fontWeight: "bolder", color: theme.palette.common.white };
  if (props.customStyles) {
    chipStyles = Object.assign({}, props.customStyles, chipStyles);
  }
  var lbl = "";
  if (showTitle) {
    lbl = lbl + props.apl.genericTypes[props.type].title;
  }

  for (var x = 0; x < props.apl.genericTypes[props.type].data.length; x++) {
    if (props.apl.genericTypes[props.type].data[x].id == props.typeId) {
      // if a typeID match is found, concat the target field to the type title field and return the chip
      if (
        props.apl.genericTypes[props.type].data[x].bgColorTag &&
        props.apl.genericTypes[props.type].data[x].bgColorTag != null
      ) {
        chipStyles.backgroundColor =
          "#" + props.apl.genericTypes[props.type].data[x].bgColorTag;
      }
      if (
        props.apl.genericTypes[props.type].data[x].txtColorTag &&
        props.apl.genericTypes[props.type].data[x].txtColorTag != null
      ) {
        chipStyles.color =
          "#" + props.apl.genericTypes[props.type].data[x].txtColorTag;
      }

      // Modern styling for specific status types using theme
      let modernChipProps;
      const description = props.apl.genericTypes[props.type].data[x].description;
      
      if (description == "Active") {
        modernChipProps = getChipVariant('active', theme);
      } else if (description == "Inactive") {
        modernChipProps = getChipVariant('inactive', theme);
      } else if (description == "Tenant") {
        modernChipProps = getChipVariant('tenant', theme);
      } else {
        // Default modern styling for other statuses
        modernChipProps = getChipVariant('default', theme);
      }
      
      // Apply custom styles if provided, but preserve theme colors
      if (props.customStyles && !modernChipProps.style) {
        modernChipProps.style = { ...chipStyles };
      }
      
      modernChipProps.size = condensed ? "small" : "medium";

      return (
        <Chip
          //icon={props.icon}
          label={
            lbl +
            props.apl.genericTypes[props.type].data[x][
            props.apl.genericTypes[props.type].valueToDisplay
            ]
          } // Yikes, was more ellegant in my head lol
          {...modernChipProps}
        />
      );
    }
  }
  // If the for loop ends and nothing is found return the unknown tag with modern styling
  const unknownChipProps = getChipVariant('warning', theme);
  return (
    <Chip
      //icon={props.icon}
      label={lbl + MissingTypeIDValue}
      {...unknownChipProps}
      size={condensed ? "small" : "medium"}
    />
  );
};

// Component Properties
StatusTag.propTypes = {
  // Store objects:
  apl: PropTypes.object.isRequired,
  getAllGenericDBStatusOrTypeData: PropTypes.func.isRequired,
};

// Component State
function StatusTagState(state) {
  return {
    apl: state.apl,
  };
}
export default connect(StatusTagState, { getAllGenericDBStatusOrTypeData })(
  StatusTag
);
